let CorrelationStackingCombinations = {
    CORRELATION_STACKING_COMBO_SET_EXPOSURE_MAX: 'CORRELATION_STACKING_COMBO_SET_EXPOSURE_MAX',
    CORRELATION_STACKING_SET_COMBINATION_GROUPS: 'CORRELATION_STACKING_SET_COMBINATION_GROUPS',
};

export default CorrelationStackingCombinations;
